"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbrManagerDazn_1 = require("../../Abr/AbrManagerDazn");
var CONFIG_ABR_MANAGER_1 = require("../Constants/CONFIG_ABR_MANAGER");
function createAbrManagerDazn(httpRequestMonitor, stateMachine, retry) {
    var abrManager = new AbrManagerDazn_1.default(httpRequestMonitor, stateMachine, retry);
    abrManager.configureDazn(CONFIG_ABR_MANAGER_1.default);
    return abrManager;
}
exports.default = createAbrManagerDazn;
//# sourceMappingURL=createAbrManagerDazn.js.map